if (!customElements.get('inline-countdown')) {
  class InlineCountdown extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
    }

    connectedCallback() {
      this.days = this.querySelector('.inline-countdown__days');
      this.hours = this.querySelector('.inline-countdown__hours');
      this.minutes = this.querySelector('.inline-countdown__minutes');
      this.seconds = this.querySelector('.inline-countdown__seconds');

      this.replaceTarget = this.dataset.replaceTarget || null;
      this.format = this.dataset.format || 'default';

      if (!this.days && !this.hours && !this.minutes && !this.seconds) return;

      requestAnimationFrame(this.updateCountdown.bind(this));
      this.timer = setInterval(this.updateCountdown.bind(this), 200);
    }

    disconnectedCallback() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    }

    updateCountdown() {
      const now = Math.floor(new Date().getTime() / 1000);
      let timestamp = +this.dataset.target - now;
      const ogTimestamp = timestamp;

      if (timestamp <= 0 && this.hasAttribute('remove-end')) {
        requestAnimationFrame(this.replaceSection.bind(this));
      }

      let days = 0,
        hours = 0,
        minutes = 0,
        seconds = 0;

      if (this.seconds && !this.minutes && !this.hours && !this.days) {
        seconds = timestamp;
      } else if (this.seconds && this.minutes && !this.hours && !this.days) {
        seconds = Math.floor(timestamp % 60);
        minutes = Math.floor((timestamp - seconds) / 60);
      } else if (this.seconds && this.minutes && this.hours && !this.days) {
        seconds = Math.floor(timestamp % 60);
        timestamp = Math.floor((timestamp - seconds) / 60);
        minutes = Math.floor(timestamp % 60);
        hours = Math.floor((timestamp - minutes) / 60);
      } else if (this.seconds && this.minutes && this.hours && !this.days) {
        seconds = Math.floor(timestamp % 60);
        timestamp = Math.floor((timestamp - seconds) / 60);
        minutes = Math.floor(timestamp % 60);
        hours = Math.floor((timestamp - minutes) / 60);
      } else {
        seconds = Math.floor(timestamp % 60);
        timestamp = Math.floor((timestamp - seconds) / 60);
        minutes = Math.floor(timestamp % 60);
        timestamp = Math.floor((timestamp - minutes) / 60);
        hours = Math.floor(timestamp % 24);
        days = Math.floor((timestamp - hours) / 24);
      }

      if (this.days)
        this.days.querySelector('span').textContent =
          this.format == 'numeric' ? this.formatLeadingZero(Math.max(days, 0)) : Math.max(days, 0);
      if (this.hours)
        this.hours.querySelector('span').textContent =
          this.format == 'numeric' ? this.formatLeadingZero(Math.max(hours, 0)) : Math.max(hours, 0);
      if (this.minutes)
        this.minutes.querySelector('span').textContent =
          this.format == 'numeric' ? this.formatLeadingZero(Math.max(minutes, 0)) : Math.max(minutes, 0);
      if (this.seconds)
        this.seconds.querySelector('span').textContent =
          this.format == 'numeric' ? this.formatLeadingZero(Math.max(seconds, 0)) : Math.max(seconds, 0);

      if (this.hasAttribute('hide-zero')) {
        if (days <= 0) {
          if (this.days) this.days.classList.add('hidden');
        } else {
          if (this.days) this.days.classList.remove('hidden');
        }

        if (hours <= 0 && days <= 0) {
          if (this.hours) this.hours.classList.add('hidden');
        } else {
          if (this.hours) this.hours.classList.remove('hidden');
        }

        if (minutes <= 0 && hours <= 0 && days <= 0) {
          if (this.minutes) this.minutes.classList.add('hidden');
        } else {
          if (this.minutes) this.minutes.classList.remove('hidden');
        }

        if (seconds <= 0 && minutes <= 0 && hours <= 0 && days <= 0) {
          if (this.seconds) this.seconds.classList.add('hidden');
        } else {
          if (this.seconds) this.seconds.classList.remove('hidden');
        }
      }

      if (ogTimestamp <= 0) {
        clearInterval(this.timer);
        return;
      }
    }

    replaceSection() {
      if (!this.replaceTarget) return;

      fetch(window.location.href)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const currentSection = document.querySelector(this.replaceTarget);
          const newSection = html.querySelector(this.replaceTarget);

          currentSection.innerHTML = newSection.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }

    formatLeadingZero(num, characters = 2) {
      return num.toString().padStart(characters, '0');
    }
  }

  customElements.define('inline-countdown', InlineCountdown);
}
